module.exports = __webpack_public_path__ + "static/media/DOG_SELECTIVE.63f27382.svg";